export default "__VITE_ASSET__B9come$O__"